
export default function VPNService() {
  const features = [
    {
      icon: 'ri-global-line',
      title: 'Worldwide Coverage',
      description: 'Access servers in over 50 countries with optimized routing for maximum speed and reliability wherever you are'
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Military-Grade Security',
      description: 'Advanced encryption protocols including OpenVPN, IKEv2, and WireGuard ensure your data remains completely private and secure'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Performance',
      description: 'Enjoy unlimited bandwidth with zero throttling on our high-speed servers optimized for streaming, gaming, and browsing'
    }
  ];

  return (
    <section id="vpn-service" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-20">
          <p className="text-sm text-gray-500 uppercase tracking-widest mb-4 whitespace-nowrap">OUR SERVICES</p>
          <h2 className="text-5xl font-extrabold text-black leading-tight">
            Complete VPN Solution<br />
            For Your Needs
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-12 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-8">
                <i className={`${feature.icon} text-5xl text-cyan-400`} style={{ strokeWidth: '3px' }}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-black mb-5 whitespace-nowrap">{feature.title}</h3>
              
              <p className="text-gray-600 text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
